import { apiNerisService } from './apiNerisService';

export const syncStationsWithV3 = async (params) => {
  const data = await apiNerisService
    .post('/station/web', params)
    .then((item) => item)
    .catch((err) => console.error(err));

  return data;
};

export const getStations = async (params) => {
  const data = await apiNerisService
    .get('/station', params || {})
    .then((item) => item)
    .catch((err) => console.error(err));

  return data;
};

export const createStation = async (params) => {
  try {
    await apiNerisService.post('/station', params || {});
  } catch (error) {
    console.error(error);
  }
};

export const updateStation = async (params, id) => {
  try {
    await apiNerisService.patch(`/station/${id}`, params || {});
  } catch (error) {
    console.error(error);
  }
};

export const deleteStation = async (id) => {
  try {
    await apiNerisService.delete(`/station/${id}`);
  } catch (error) {
    console.error(error);
  }
};

export const syncStationUnitsWithV3 = async (params) => {
  const data = await apiNerisService
    .post('/unit/web', params)
    .then((item) => item)
    .catch((err) => console.error(err));

  return data;
};

export const createUnit = async (params, stationId) => {
  try {
    await apiNerisService.post(`/station/${stationId}/units`, params || {});
  } catch (error) {
    console.error(error);
  }
};

export const updateUnit = async (params, stationId, unitId) => {
  try {
    await apiNerisService.patch(
      `/station/${stationId}/units/${unitId}`,
      params || {}
    );
  } catch (error) {
    console.error(error);
  }
};

export const deleteUnit = async (stationId, unitId) => {
  try {
    await apiNerisService.delete(`/station/${stationId}/units/${unitId}`);
  } catch (error) {
    console.error(error);
  }
};

export const getUnits = async (params, stationId) => {
  const data = await apiNerisService
    .get(`/station/${stationId}/unit`, params || {})
    .then((item) => item)
    .catch((err) => console.error(err));

  return data;
};

export const getAllUnits = async (params) => {
  const data = await apiNerisService
    .get(`/station/units`, params || {})
    .then((item) => item)
    .catch((err) => console.error(err));

  return data;
};

export const updateUnitDirect = async (params, unitId) => {
  try {
    await apiNerisService.patch(`/unit/${unitId}`, params || {});
  } catch (error) {
    console.error(error);
  }
};

export const getStationsStatesEnum = async (params) => {
  try {
    return await apiNerisService.get(`/info/states`, params || {});
  } catch (error) {
    console.error(error);
  }
};

export const getUnitTypesEnum = async (params) => {
  try {
    return await apiNerisService.get(`/info/unit/types`);
  } catch (error) {
    console.error(error);
  }
};
